import { Icon } from '../../../../core/components/atoms/Icon';

export function CardEmpty() {
  return (
    <div className='flex w-3/5 flex-col gap-sm rounded-md border-[1px] border-dashed border-mono-color-medium p-4'>
      <div className='flex flex-row items-center gap-sm'>
        <div className='h-[21px] w-[21px] rounded-circular bg-mono-color-light' />
        <div className='flex flex-col gap-xs'>
          <div className='h-1 w-16 bg-mono-color-light' />
          <div className='h-1 w-16 bg-mono-color-light' />
        </div>
      </div>
      <div className='flex flex-col gap-xs'>
        <div className='h-1 w-full bg-mono-color-light' />
        <div className='h-1 w-36 bg-mono-color-light' />
      </div>
      <div className='flex flex-row items-center justify-between'>
        <div className='bg-mono-color-lighth-1 w-16' />
        <Icon
          Icon='star'
          type='material'
          variant='rounded'
          className='filled text-lg text-brand-color-secondary-pure'
        />
      </div>
    </div>
  );
}
